import { Box, Paper, Stack, Typography } from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { ActionItem } from "../../../types/types";

interface ActionItemCardProps {
  item: ActionItem;
}

export default function ActionItemCard({ item }: ActionItemCardProps) {
  return (
    <Paper
      sx={{
        borderRadius: "12px",
        p: 1,
        boxShadow: 0,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
          sx={{
            width: 45,
            height: 45,
            borderRadius: "50%",
            bgcolor: "background.paper",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {item.icon}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "13px",
              lineHeight: 1.5,
            }}
          >
            {item.title}
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "11px",
              color: "#cbd5e1",
              lineHeight: 1.5,
            }}
          >
            {item.subtitle}
          </Typography>
        </Box>
        <ExpandMore sx={{ fontSize: 18, color: "#cbd5e1" }} />
      </Stack>
    </Paper>
  );
}
